import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { getters, actions } from "../../../model";
import { isEmptyOrNil } from "utils/General";

import { DOCUMENT_REQUEST_REVISIONS } from "utils/standard-module-field-ids";

import { noop } from "utils/General";

import CSSModules from "react-css-modules";
import css from "./styles.scss";

import { showModal } from "redux/modules/modal/actions";

import FileRevision from "./FileRevision";
import { getMarkCompletedAsViewOnly } from "../../../selectors";

const { FILES } = DOCUMENT_REQUEST_REVISIONS;

const decorate = R.compose(
  CSSModules(css),
  connect(
    state => ({
      file: getters.fileUploadData(state),
      value: getters.fileUploadProgress(state),
      fileUploadUploadHasFinished: getters.fileUploadUploadHasFinished(state),
      loading: getters.loadingFileUpload(state),
      revisions: getters.files(state),
      loadingSavingFile: getters.loadingSavingFile(state),
      markCompletedAsViewOnly: getMarkCompletedAsViewOnly(state)
    }),
    {
      cancelUpload: actions.cancelFileUpload,
      deleteFile: actions.cleanFileUploadState,
      showModal
    }
  )
);

const RenderRevision = ({ revision, showModal }) => {
  const files = R.pathOr([], ["values", FILES, "value", "files"], revision);
  return R.map(
    file => (
      <FileRevision
        key={file.id}
        file={file}
        files={files}
        showModal={showModal}
      />
    ),
    files
  );
};

const FileUpload = ({
  value = 50,
  file = undefined,
  cancelUpload,
  fileUploadUploadHasFinished,
  loading = true,
  revisions = [],
  showModal = noop,
  deleteFile = noop,
  loadingSavingFile = false,
  markCompletedAsViewOnly = false,
  isClosed = false
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {!loading && (
        <div
          style={{
            color: "#494949",
            fontSize: "16px",
            fontWeight: "600",
            wordWrap: "break-word"
          }}
        >
          Files
        </div>
      )}
      {isClosed || markCompletedAsViewOnly ? null : (
        <div
          style={{
            marginBottom: 20,
            cursor: "pointer",
            display: !isEmptyOrNil(file) && !loading ? "none" : "inherit",
            ...(loading ? { opacity: 0 } : { opacity: 1 })
          }}
          id="dropzone-container"
        ></div>
      )}
      {!isEmptyOrNil(file) && (
        <FileRevision
          file={file}
          cancelUpload={cancelUpload}
          fileUploadUploadHasFinished={fileUploadUploadHasFinished}
          deleteFile={() => {
            deleteFile();
          }}
          value={value}
          isPreUploading
          showModal={showModal}
          loadingSavingFile={loadingSavingFile}
        />
      )}
      {!loading && R.length(revisions) > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <div>Version History</div>
          {R.map(
            r => (
              <RenderRevision key={r.id} revision={r} showModal={showModal} />
            ),
            revisions
          )}
        </div>
      )}
    </div>
  );
};

export default decorate(FileUpload);
